module.exports = __webpack_public_path__ + "assets/img/nh3.0ff89dd0.jpg";